import React from "react";

/**
 * TermsCheckbox — "I agree to the Terms & Conditions" for sign-up forms. The link opens in a new tab
 * so whatever the visitor has typed stays put.
 */
export default function TermsCheckbox({ id, checked, onChange, className = "" }) {
  return (
    <label htmlFor={id} className={`flex items-start gap-3 text-sm cursor-pointer ${className}`}>
      <input
        id={id}
        type="checkbox"
        required
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-5 w-5 shrink-0 accent-[#F6A81E] cursor-pointer"
      />
      <span className="opacity-80">
        I agree to the{" "}
        <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-[#F6A81E] underline">
          Terms & Conditions
        </a>
        <span className="sr-only"> (opens in a new tab)</span>.
      </span>
    </label>
  );
}
